
function CTextConverter()
{
    const textBank = {};

    CTextConverter.prototype.loadText = function (languageType) {
        const LANGUAGE_TYPE = require("./Language");
        let myPromise = null;
        switch (languageType) {
            case LANGUAGE_TYPE.zh_TW:
                myPromise = new Promise((resolve, reject) => {
                    fetch("language/zh_TW.json")
                        .then(response => response.json())
                        .then(json => {
                            const keys = Object.keys(json);
                            keys.forEach((key) => {
                                textBank[key] = json[key];
                            });
                            resolve();
                        })
                        .catch(err => {
                            reject(err.message);
                        });
                });
                break;
            case LANGUAGE_TYPE.en_US:
                myPromise = new Promise((resolve, reject) => {
                    fetch("language/en_US.json")
                        .then(response => response.json())
                        .then(json => {
                            const keys = Object.keys(json);
                            keys.forEach((key) => {
                                textBank[key] = json[key];
                            });
                            resolve();
                        })
                        .catch(err => {
                            reject(err.message);
                        });
                });
                break;
            default:
                break;
        }
        return myPromise;
    }

    CTextConverter.prototype.convert = function(text) {
        if (text) {
            if (textBank.hasOwnProperty(text)) return textBank[text];
        }
        return text;
    }
}

module.exports = CTextConverter;